/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class DateDialog extends SiteEntityDialog<DateRow, any> {
        protected getFormKey() { return DateForm.formKey; }
        protected getIdProperty() { return DateRow.idProperty; }
        protected getLocalTextPrefix() { return DateRow.localTextPrefix; }
        protected getNameProperty() { return DateRow.nameProperty; }
        protected getService() { return DateService.baseUrl; }

        protected form = new DateForm(this.idPrefix);

    }
}